/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { ChangeInvoiceStatusV1200ResponseFromJSON, ConsumerToJSON, GetInvoicePreviewFileV1RequestToJSON, GetProtocolV1200ResponseFromJSON, InvoiceStatusToJSON, LeadToJSON, ProducerToJSON, } from '../models/index';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     */
    async corsAnnexesOfContractV1Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling corsAnnexesOfContractV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/contracts/{contract_number}/annexes`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsAnnexesOfContractV1(requestParameters, initOverrides) {
        await this.corsAnnexesOfContractV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsChangeInvoiceStatusV1Raw(requestParameters, initOverrides) {
        if (requestParameters['invoiceNumber'] == null) {
            throw new runtime.RequiredError('invoiceNumber', 'Required parameter "invoiceNumber" was null or undefined when calling corsChangeInvoiceStatusV1().');
        }
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError('data', 'Required parameter "data" was null or undefined when calling corsChangeInvoiceStatusV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/v1/invoices/{invoice_number}/status`.replace(`{${"invoice_number"}}`, encodeURIComponent(String(requestParameters['invoiceNumber']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceStatusToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeInvoiceStatusV1200ResponseFromJSON(jsonValue));
    }
    /**
     */
    async corsChangeInvoiceStatusV1(requestParameters, initOverrides) {
        const response = await this.corsChangeInvoiceStatusV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async corsClientTypeV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/profiles`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsClientTypeV1(initOverrides) {
        await this.corsClientTypeV1Raw(initOverrides);
    }
    /**
     */
    async corsContractFileV1Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling corsContractFileV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/contract/{contract_number}/file`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsContractFileV1(requestParameters, initOverrides) {
        await this.corsContractFileV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsCreateConsumerV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/v1/consumers`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
            body: ConsumerToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsCreateConsumerV1(requestParameters = {}, initOverrides) {
        await this.corsCreateConsumerV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsCreateLeadV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/v1/leads`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
            body: LeadToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsCreateLeadV1(requestParameters = {}, initOverrides) {
        await this.corsCreateLeadV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsCreateProducerV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/v1/producers`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
            body: ProducerToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsCreateProducerV1(requestParameters = {}, initOverrides) {
        await this.corsCreateProducerV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsFileUploadV1Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling corsFileUploadV1().');
        }
        if (requestParameters['uploadFile'] == null) {
            throw new runtime.RequiredError('uploadFile', 'Required parameter "uploadFile" was null or undefined when calling corsFileUploadV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['uploadFile'] != null) {
            formParams.append('upload_file', requestParameters['uploadFile']);
        }
        const response = await this.request({
            path: `/v1/contracts/{contract_number}/file`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsFileUploadV1(requestParameters, initOverrides) {
        await this.corsFileUploadV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetAllContractsV2Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/contracts`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetAllContractsV2(initOverrides) {
        await this.corsGetAllContractsV2Raw(initOverrides);
    }
    /**
     */
    async corsGetAllDueInvoicesV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/invoices/due`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetAllDueInvoicesV1(initOverrides) {
        await this.corsGetAllDueInvoicesV1Raw(initOverrides);
    }
    /**
     */
    async corsGetAllDueMeteringPointsV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/metering-points/due`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetAllDueMeteringPointsV1(initOverrides) {
        await this.corsGetAllDueMeteringPointsV1Raw(initOverrides);
    }
    /**
     */
    async corsGetAllInvoicesV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/invoices`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetAllInvoicesV1(initOverrides) {
        await this.corsGetAllInvoicesV1Raw(initOverrides);
    }
    /**
     */
    async corsGetAllMeteringPointsV2Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/metering-points`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetAllMeteringPointsV2(initOverrides) {
        await this.corsGetAllMeteringPointsV2Raw(initOverrides);
    }
    /**
     */
    async corsGetAllProtocolsV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/protocols`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetAllProtocolsV1(initOverrides) {
        await this.corsGetAllProtocolsV1Raw(initOverrides);
    }
    /**
     */
    async corsGetContractByNumberV2Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling corsGetContractByNumberV2().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/contracts/{contract_number}`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetContractByNumberV2(requestParameters, initOverrides) {
        await this.corsGetContractByNumberV2Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetCustomerContactsV1Raw(requestParameters, initOverrides) {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling corsGetCustomerContactsV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/customers/{customer_id}/contacts`.replace(`{${"customer_id"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetCustomerContactsV1(requestParameters, initOverrides) {
        await this.corsGetCustomerContactsV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetCustomerContractsV1Raw(requestParameters, initOverrides) {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling corsGetCustomerContractsV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/customers/{customer_id}/contracts`.replace(`{${"customer_id"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetCustomerContractsV1(requestParameters, initOverrides) {
        await this.corsGetCustomerContractsV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetCustomerDetailsV1Raw(requestParameters, initOverrides) {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling corsGetCustomerDetailsV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/customers/{customer_id}`.replace(`{${"customer_id"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetCustomerDetailsV1(requestParameters, initOverrides) {
        await this.corsGetCustomerDetailsV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetCustomerInvoicesV1Raw(requestParameters, initOverrides) {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling corsGetCustomerInvoicesV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/customers/{customer_id}/invoices`.replace(`{${"customer_id"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetCustomerInvoicesV1(requestParameters, initOverrides) {
        await this.corsGetCustomerInvoicesV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetCustomerMeteringPointsV2Raw(requestParameters, initOverrides) {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling corsGetCustomerMeteringPointsV2().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/customers/{customer_id}/metering-points`.replace(`{${"customer_id"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetCustomerMeteringPointsV2(requestParameters, initOverrides) {
        await this.corsGetCustomerMeteringPointsV2Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetElectricityConsumptionSummaryV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/reports/electricity-consumption-summary`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetElectricityConsumptionSummaryV1(initOverrides) {
        await this.corsGetElectricityConsumptionSummaryV1Raw(initOverrides);
    }
    /**
     */
    async corsGetElectricityConsumptionV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/reports/electricity-consumption`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetElectricityConsumptionV1(initOverrides) {
        await this.corsGetElectricityConsumptionV1Raw(initOverrides);
    }
    /**
     */
    async corsGetInvoiceDetailsV1Raw(requestParameters, initOverrides) {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter "invoiceId" was null or undefined when calling corsGetInvoiceDetailsV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/invoices/{invoice_id}`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters['invoiceId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetInvoiceDetailsV1(requestParameters, initOverrides) {
        await this.corsGetInvoiceDetailsV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetListOfCustomersByEmailV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/customers`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetListOfCustomersByEmailV1(initOverrides) {
        await this.corsGetListOfCustomersByEmailV1Raw(initOverrides);
    }
    /**
     */
    async corsGetMeteringPointContactsV1Raw(requestParameters, initOverrides) {
        if (requestParameters['meteringPointId'] == null) {
            throw new runtime.RequiredError('meteringPointId', 'Required parameter "meteringPointId" was null or undefined when calling corsGetMeteringPointContactsV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/metering-points/{metering_point_id}/contacts`.replace(`{${"metering_point_id"}}`, encodeURIComponent(String(requestParameters['meteringPointId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetMeteringPointContactsV1(requestParameters, initOverrides) {
        await this.corsGetMeteringPointContactsV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetMeteringPointContractV2Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling corsGetMeteringPointContractV2().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/contracts/{contract_number}/metering-points`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetMeteringPointContractV2(requestParameters, initOverrides) {
        await this.corsGetMeteringPointContractV2Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetMeteringPointInvoicesV2Raw(requestParameters, initOverrides) {
        if (requestParameters['meteringPointId'] == null) {
            throw new runtime.RequiredError('meteringPointId', 'Required parameter "meteringPointId" was null or undefined when calling corsGetMeteringPointInvoicesV2().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/metering-points/{metering_point_id}/invoices`.replace(`{${"metering_point_id"}}`, encodeURIComponent(String(requestParameters['meteringPointId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetMeteringPointInvoicesV2(requestParameters, initOverrides) {
        await this.corsGetMeteringPointInvoicesV2Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetMeteringPointV2Raw(requestParameters, initOverrides) {
        if (requestParameters['meteringPointId'] == null) {
            throw new runtime.RequiredError('meteringPointId', 'Required parameter "meteringPointId" was null or undefined when calling corsGetMeteringPointV2().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/metering-points/{metering_point_id}`.replace(`{${"metering_point_id"}}`, encodeURIComponent(String(requestParameters['meteringPointId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetMeteringPointV2(requestParameters, initOverrides) {
        await this.corsGetMeteringPointV2Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsGetOverduePaymentsV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/reports/overdue-payment-amount`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetOverduePaymentsV1(initOverrides) {
        await this.corsGetOverduePaymentsV1Raw(initOverrides);
    }
    /**
     */
    async corsGetPlanPricesV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/plan_prices`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetPlanPricesV1(initOverrides) {
        await this.corsGetPlanPricesV1Raw(initOverrides);
    }
    /**
     */
    async corsGetTotalAmountDueV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/reports/total-amount-due`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsGetTotalAmountDueV1(initOverrides) {
        await this.corsGetTotalAmountDueV1Raw(initOverrides);
    }
    /**
     */
    async corsHealthCheckV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/health-check`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsHealthCheckV1(initOverrides) {
        await this.corsHealthCheckV1Raw(initOverrides);
    }
    /**
     */
    async corsProtocolsRaw(requestParameters, initOverrides) {
        if (requestParameters['protocolId'] == null) {
            throw new runtime.RequiredError('protocolId', 'Required parameter "protocolId" was null or undefined when calling corsProtocols().');
        }
        if (requestParameters['protocolNumber'] == null) {
            throw new runtime.RequiredError('protocolNumber', 'Required parameter "protocolNumber" was null or undefined when calling corsProtocols().');
        }
        if (requestParameters['invoiceFile'] == null) {
            throw new runtime.RequiredError('invoiceFile', 'Required parameter "invoiceFile" was null or undefined when calling corsProtocols().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['protocolNumber'] != null) {
            formParams.append('protocol_number', requestParameters['protocolNumber']);
        }
        if (requestParameters['invoiceFile'] != null) {
            formParams.append('invoice_file', requestParameters['invoiceFile']);
        }
        const response = await this.request({
            path: `/v1/protocols/{protocol_id}`.replace(`{${"protocol_id"}}`, encodeURIComponent(String(requestParameters['protocolId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetProtocolV1200ResponseFromJSON(jsonValue));
    }
    /**
     */
    async corsProtocols(requestParameters, initOverrides) {
        const response = await this.corsProtocolsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async corsSearchCustomersV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/impersonalized-customers`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsSearchCustomersV1(initOverrides) {
        await this.corsSearchCustomersV1Raw(initOverrides);
    }
    /**
     */
    async corsTokiGPTV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/tokigpt`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsTokiGPTV1(initOverrides) {
        await this.corsTokiGPTV1Raw(initOverrides);
    }
    /**
     */
    async corsgetAnnexURLV1Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling corsgetAnnexURLV1().');
        }
        if (requestParameters['annexNumber'] == null) {
            throw new runtime.RequiredError('annexNumber', 'Required parameter "annexNumber" was null or undefined when calling corsgetAnnexURLV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/annexes/{contract_number}/{annex_number}`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))).replace(`{${"annex_number"}}`, encodeURIComponent(String(requestParameters['annexNumber']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsgetAnnexURLV1(requestParameters, initOverrides) {
        await this.corsgetAnnexURLV1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async corsgetInvoicePreviewFileV1Raw(requestParameters, initOverrides) {
        if (requestParameters['protocolId'] == null) {
            throw new runtime.RequiredError('protocolId', 'Required parameter "protocolId" was null or undefined when calling corsgetInvoicePreviewFileV1().');
        }
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError('data', 'Required parameter "data" was null or undefined when calling corsgetInvoicePreviewFileV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/v1/protocols/{protocol_id}/invoice`.replace(`{${"protocol_id"}}`, encodeURIComponent(String(requestParameters['protocolId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
            body: GetInvoicePreviewFileV1RequestToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async corsgetInvoicePreviewFileV1(requestParameters, initOverrides) {
        await this.corsgetInvoicePreviewFileV1Raw(requestParameters, initOverrides);
    }
}
